import cx from 'classnames';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { EmailSupport } from '@shared/components/emailSupport/EmailSupport';
import { RestaurantContext } from 'webReservations/context/RestaurantContext';
import {
  ABOUT_US_PATH,
  FAQ_PATH,
  PRIVACY_POLICY_PATH,
  TERMS_OF_SERVICE_PATH,
} from '../paths';
import styles from './Footer.scss';

export const Footer = () => {
  const restaurantContext = useContext(RestaurantContext);
  const supportEmail =
    restaurantContext?.restaurantDetails?.supportEmail ?? undefined;

  return (
    <footer className={styles.footer}>
      <nav className={styles.links}>
        <Link className={styles.link} to={ABOUT_US_PATH}>
          About Peak
        </Link>
        <Link className={styles.link} to={TERMS_OF_SERVICE_PATH}>
          Terms of Service
        </Link>
        <Link className={styles.link} to={PRIVACY_POLICY_PATH}>
          Privacy Policy
        </Link>
        <EmailSupport
          className={cx(styles.link, styles.supportLink)}
          label="Support"
          to={supportEmail}
        />
        <Link className={styles.link} to={FAQ_PATH}>
          FAQ
        </Link>
      </nav>
    </footer>
  );
};
